import React, { useEffect, useRef, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import UiIcon from '../ui/UiIcon';
import './BitcoinSendPanel.css';

export const bitcoinPaymentUri = address => `bitcoin:${address}?label=Ty0x7`;
export const bitcoinProviderUrl = 'https://www.bitpay.com/buy-bitcoin?crypto=BTC';

// This is a public payment destination, not a wallet or transaction service.
// The visitor chooses the amount and approves it with their own provider.
const BitcoinSendPanel = ({ address, onClose }) => {
  const headingRef = useRef(null);
  const addressRef = useRef(null);
  const [copyStatus, setCopyStatus] = useState('');
  const uri = bitcoinPaymentUri(address);
  useEffect(() => headingRef.current?.focus({ preventScroll: false }), []);

  const copyAddress = async () => {
    try {
      await navigator.clipboard.writeText(address);
      setCopyStatus('Bitcoin address copied.');
    } catch {
      addressRef.current?.focus();
      addressRef.current?.select();
      setCopyStatus('Select and copy the address below.');
    }
  };

  return <section id="bitcoin-send-panel" className="bitcoin-send-panel" aria-labelledby="bitcoin-send-title">
    <header><div><span>BITCOIN / ON CHAIN</span><h3 id="bitcoin-send-title" ref={headingRef} tabIndex={-1}>Send BTC to Ty0x7</h3></div><button type="button" onClick={onClose} aria-label="Close Bitcoin send options"><UiIcon name="close" /></button></header>
    <div className="bitcoin-send-options">
      <div className="bitcoin-send-qr"><QRCodeSVG value={uri} size={168} level="M" marginSize={4} bgColor="#ffffff" fgColor="#103662" title="Scan to send Bitcoin to Ty0x7" /><span>Scan with a Bitcoin wallet</span></div>
      <div className="bitcoin-send-methods">
        <a className="bitcoin-wallet-link" href={uri}>Open my wallet <UiIcon name="external" /></a>
        <p>Choose an amount and review the transfer in your wallet. Use the Bitcoin network only.</p>
        <button type="button" onClick={copyAddress}>Copy BTC address <UiIcon name="copy" /></button>
        <a href={bitcoinProviderUrl} target="_blank" rel="noopener noreferrer">Buy and send with BitPay <UiIcon name="external" /></a>
        <p>Copy this address, then paste it as the receiving wallet at checkout. Payment methods, fees, minimums, and identity checks depend on your location and provider.</p>
      </div>
    </div>
    <label className="bitcoin-send-address"><span>Receiving address</span><input ref={addressRef} value={address} readOnly aria-label="Bitcoin receiving address" onFocus={event => event.target.select()} /></label>
    <p className="bitcoin-send-status" role="status">{copyStatus}</p>
    <small>Verify the address before confirming. Bitcoin transfers cannot be reversed. This site never signs a transaction or asks for wallet credentials.</small>
  </section>;
};

export default BitcoinSendPanel;
